import { contentService } from '../services/api';
import { trackWhatsAppClick } from './tracking';
import { toWhatsAppPhone } from './whatsappPhone';
import { withOriginCode } from './siteEvents';

interface WhatsAppSettings {
  whatsapp_number: string;
  whatsapp_lead_message: string;
  whatsapp_property_message: string;
  whatsapp_enabled: boolean;
}

interface LeadData {
  name: string;
  email: string;
  phone: string;
  message?: string;
  propertyId?: string;
  propertyTitle?: string;
}

export class WhatsAppService {
  private static settings: WhatsAppSettings | null = null;

  static async loadSettings(): Promise<WhatsAppSettings | null> {
    try {
      if (!this.settings) {
        const data = await contentService.getSiteSettings();
        this.settings = {
          whatsapp_number: data.whatsapp_number || '',
          whatsapp_lead_message: data.whatsapp_lead_message || '',
          whatsapp_property_message: data.whatsapp_property_message || '',
          whatsapp_enabled: data.whatsapp_enabled !== false
        };
      }
      return this.settings;
    } catch (error) {
      console.error('Erro ao carregar configurações do WhatsApp:', error);
      return null;
    }
  }

  static buildMessage(template: string, leadData: LeadData): string {
    const baseUrl = window.location.origin;
    let message = template;

    message = message.replace('{site_url}', baseUrl);
    message = message.replace('{name}', leadData.name);
    message = message.replace('{email}', leadData.email);
    message = message.replace('{phone}', leadData.phone);

    if (leadData.propertyId && leadData.propertyTitle) {
      const propertyUrl = `${baseUrl}/imovel/${leadData.propertyId}`;
      message = message.replace('{property_title}', leadData.propertyTitle);
      message = message.replace('{property_url}', propertyUrl);
      message = message.replace('{property_id}', leadData.propertyId);
    }

    if (leadData.message) {
      message += `\n\nMensagem: ${leadData.message}`;
    }

    return withOriginCode(message);
  }

  static buildWhatsAppUrl(message: string, phoneNumber: string): string {
    const encodedMessage = encodeURIComponent(message);
    const phone = toWhatsAppPhone(phoneNumber) || phoneNumber.replace(/\D/g, '');
    return `https://api.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;
  }

  static async sendToWhatsApp(leadData: LeadData): Promise<boolean> {
    const settings = await this.loadSettings();
    
    if (!settings?.whatsapp_enabled || !settings?.whatsapp_number) {
      console.log('WhatsApp não configurado ou desabilitado');
      return false;
    }

    try {
      const template = leadData.propertyId 
        ? settings.whatsapp_property_message 
        : settings.whatsapp_lead_message;

      const message = this.buildMessage(template, leadData);
      const whatsappUrl = this.buildWhatsAppUrl(message, settings.whatsapp_number);

      trackWhatsAppClick(leadData.propertyId ? 'property_detail' : 'lead_form');
      window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
      return true;
    } catch (error) {
      console.error('Erro ao enviar para WhatsApp:', error);
      return false;
    }
  }

  static async showWhatsAppOption(leadData: LeadData): Promise<boolean> {
    const settings = await this.loadSettings();
    
    if (!settings?.whatsapp_enabled) {
      return false;
    }

    return new Promise((resolve) => {
      const message = `Dados enviados com sucesso!\n\nDeseja continuar a conversa pelo WhatsApp?`;
      
      if (window.confirm(message)) {
        this.sendToWhatsApp(leadData).then(resolve);
      } else {
        resolve(false);
      }
    });
  }
}
